import React, { useState } from 'react'
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import { Link } from "react-router-dom";
import Divider from '@mui/material/Divider'; 
import LikeButton from "../../Like/likebutton";
import { API_URL, APP_URL, Bsc_Chainid, ETH_Chainid, Matic_Chainid } from '../../../Config';
import notrevealed from '../../../images/notrevealed.jpg';
import { Notarizematicaddress ,ABINotarize } from '../../../Config';
import { useWeb3React } from '@web3-react/core';
import axios from 'axios';
import Loading from "../../../Components/loader/loader";
import swal from 'sweetalert';
import { useHistory } from 'react-router-dom';


const Notarize = (props) => {
    const {library ,account} =useWeb3React();
    const [isloading,setisloading]=useState(false);
    const {history}=useHistory();

    const revealnft=async(reveal,Nftchainid ,tokenid)=>{
        if(library){
            setisloading(true);
            const Web3=require('web3');
            const web3 =new Web3(library.provider);

            // let contract_address='';
            // if (Nftchainid == Bsc_Chainid) {
                // contract_address = bsccontractaddress;
            // } else if (Nftchainid == Matic_Chainid) {
            //     contract_address = Notarizematicaddress;
            // } else if(Nftchainid == ETH_Chainid){
                // contract_address= ethcontractaddress;
            // }

            let Private ='';
            if(reveal==true){
                Private=0;
            }else if(reveal==false){
                Private=1;
            }
            const contract = new web3.eth.Contract(ABINotarize,Notarizematicaddress);
            await contract.methods.Setisrevealed(tokenid,reveal).send({
                from: account.toString(),
            }).then(async()=>{
             
                var formdata =new FormData();
                formdata.append('Private',Private);
                formdata.append('Tokenid',tokenid);
                await axios.post(`${API_URL}/Setreveal.php`,formdata,{
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((result)=>{
                    setisloading(false)
                    console.log(result);
                    swal({
                        title: "Success",
                        text: "Updated successfully",
                        icon: "success",
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',
                    }).then(()=>{
                        window.location.reload();
                    })
                })
            }).catch(()=>{
                setisloading(false)
            });
        }
    }

    return (
        <div>
            <Box className="Profile_allnft">
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                    {props.Notarizeprop.length>0 && props.Notarizeprop.map((data,index) => (
                            <Grid key={index} item lg={3} sm={6} md={6} xs={12} marginBottom='30px'>
                                <Box className='Profile_inner'> 
                                    <Box>
                                    <Link to={`./Buydetails/${data.NFT_id}`} > 
                                    {data.NFT_image.split('.').pop()== "png" ||data.NFT_image.split('.').pop()=='jpg'||data.NFT_image.split('.').pop()=='jpeg'?
                                    <img src={data.Private==0?APP_URL+'/'+ data.NFT_image:notrevealed} width='100%' className='base_pht' style={{ borderRadius: '5px' }} /> 
                                    :data.NFT_image.split('.').pop()== "mp4" ?
                                    <video width="750" height="500" controls >
                                        <source src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} type="video/mp4"/>
                                    </video>
                                    :data.NFT_image.split('.').pop()== "mp3" ||data.NFT_image.split('.').pop()=='aac'?
                                    <audio controls>
                                    <source src={data.Private==0? APP_URL+'/'+data.NFT_image:notrevealed} type="audio/mpeg"/>
                                    Your browser does not support the audio tag.
                                    </audio> 
                                    :<img src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} width='100%' style={{ borderRadius: '5px' }} />
                                    } 
                                    </Link>
                                    </Box>
                                    <Box display='flex' justifyContent='space-between' paddingY='10px'>
                                        <Box>
                                            <Typography fontWeight='600' fontSize='22' variant='h6' color='#000'>
                                            <Link to={`./Buydetails/${data.NFT_id}`}>{data.Private==0?data.NFT_name:"SECRET NFT"}</Link>
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <LikeButton nft={data}/>
                                        </Box>
                                    </Box>
                                    <Divider />
                                    <Box paddingBottom='10px'>
                                        <Box>
                                            <Typography variant='h5' color='#000' fontWeight='600' fontSize='16px'>
                                                Reserved price
                                            </Typography>
                                            <Typography fontWeight='500' variant='h6' fontSize='15px' color='#000'>
                                                {data.NFT_price} {data.NFT_payment}
                                            </Typography>
                                            {Number(data.Notarize) === Number(1) && (
                                            <>
                                                {data.Private == 1 ?
                                                  <Button variant='contained' className='resell_nft' onClick={()=>{revealnft(true,data.Nftchainid ,data.NFT_id)}}> Make Public</Button>
                                                  :<Button variant='contained' className='resell_nft'onClick={()=>{revealnft(false,data.Nftchainid ,data.NFT_id)}}> Make Private</Button>}
                                            </> )}
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
            {isloading && <Loading/>}
        </div>
    )
}

export default Notarize ; 